// extracted by mini-css-extract-plugin
export default {"linkWrapper":"sign-requests-trace-logs-table_linkWrapper__fG+iq"};